<p-dialog header="View private events" [(visible)]="cmpVisible"
          [modal]="true" [style]="dialogStyle" [minY]="70"
          [closable]="true" (onHide)="hide()"
          [maximizable]="true" [baseZIndex]="8000">
  <app-adminlog-private></app-adminlog-private>
</p-dialog>
